import { z } from 'zod';

export interface PaginationQueryParams {
  page: number;
  pageSize: number;
}

export const paginationInfoSchema = z.object({
  totalItems: z.number().min(0),
  page: z.number().min(1),
  pageSize: z.number().min(1),
  totalPages: z.number().min(0),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
  estimatedNextPageSize: z.number().min(0),
});

export type PaginationInfo = z.infer<typeof paginationInfoSchema>;

export interface Paginated<T> extends PaginationInfo {
  items: T[];
}

export const getPaginatedItemsSchema = <T>(schema: z.ZodSchema<T>) => {
  return paginationInfoSchema.extend({
    items: z.array(schema),
  });
};
